import type { Map } from '@gonfalon/immutable-shim/immutableShim';
import { List, Record } from '@gonfalon/immutable-shim/immutableShim';

export class EnvironmentSettings extends Record<{
  startDate: number;
  stopDate?: number;
  enabledPeriods: List<Map<'startDate' | 'stopDate', number | undefined>>;
}>({ startDate: 0, stopDate: undefined, enabledPeriods: List() }) {}
